import Konva from 'konva';

export class BlockDrawOverlay {
	readonly previewRect: Konva.Rect;
	readonly widthLabel: Konva.Label;
	readonly heightLabel: Konva.Label;
	readonly percentLabel: Konva.Label;

	constructor() {
		this.previewRect = new Konva.Rect({
			x: 0,
			y: 0,
			width: 0,
			height: 0,
			stroke: '#ff5a00',
			dash: [2, 2]
		});
		this.widthLabel = new Konva.Label();
		this.heightLabel = new Konva.Label();
		this.percentLabel = new Konva.Label();

		this.heightLabel.add(
			new Konva.Tag({ rotation: -90 }),
			new Konva.Text({ text: '', fontSize: 12, rotation: -90 })
		);
		this.widthLabel.add(
			new Konva.Tag(),
			new Konva.Text({ text: '', fontSize: 12 })
		);
		this.percentLabel.add(
			new Konva.Tag(),
			new Konva.Text({ text: '', fontSize: 12 })
		);
	}

	attach(layer: Konva.Layer): void {
		layer.add(this.previewRect);
		layer.add(this.widthLabel);
		layer.add(this.heightLabel);
		layer.add(this.percentLabel);
	}

	raiseLabels(layer: Konva.Layer): void {
		layer.add(this.widthLabel);
		layer.add(this.heightLabel);
		layer.add(this.percentLabel);
	}

	hide(): void {
		this.previewRect.visible(false);
		this.previewRect.listening(true);
		this.widthLabel.hide();
		this.heightLabel.hide();
		this.percentLabel.hide();
	}

	get nodes(): Array<Konva.Node> {
		return [this.previewRect, this.widthLabel, this.heightLabel, this.percentLabel];
	}
}
